import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useGetUserProfileQuery } from "../../redux/user";
import { triggerAutoLogout } from "../AutoLogout";
import { toast } from "react-toastify";
import socket from "../constant/socket";
import ChangePasswordModal from "../partial/ChangePasswordModal";

function Header() {
  const navigate = useNavigate();
  const { data: profile, refetch, isError, error } = useGetUserProfileQuery();
  const { authenticated, logout, setIsBlock, setUserId } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isError) {
      if (!error.data.auth_status) {
        triggerAutoLogout();
      }
    }
  }, [isError]);
  useEffect(() => {
    if (profile) {
      const identifier = profile?.id;

      setUserId(profile.id);
      setIsBlock(profile.is_block);

      // Emit on initial load
      socket.emit("user-connect", identifier);

      // Handle reconnection
      const handleReconnect = () => {
        console.log("Socket reconnected");
        socket.emit("user-connect", identifier);
      };

      socket.on("connect", handleReconnect);

      return () => {
        socket.off("connect", handleReconnect);
      };
    }
  }, [profile]);

  useEffect(() => {
    if (authenticated) {
      refetch();
    }
  }, [authenticated]);
  const logoutFun = () => {
    toast.dismiss();
    toast.success("Logout Successful.");
    socket.disconnect();
    setTimeout(() => {
      logout();
      navigate("/login");
    }, 2000);
  };

  const logoutAlert = () => {
    confirmAlert({
      title: "Confirm Logout",
      message: "Are you sure you want to log out?",
      buttons: [
        {
          label: "Yes",
          onClick: () => logoutFun(),
        },
        {
          label: "No",
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  };

  const handleShow = () => {
    setShow(true);
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg nav_fix ">
        <div className="container">
          <a className="navbar-brand" href="/">
            <img src="/assets/img/logo.png" alt="Logo" />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapsibleNavbar"
          >
            <i className="bi bi-list"></i>
          </button>
          <div className="collapse navbar-collapse " id="collapsibleNavbar">
            {authenticated && (
              <ul className="navbar-nav ms-md-4 me-md-auto">
                <li className="nav-item">
                  <Link className="nav-link" to="/dashboard">
                    Dashboard
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/exchange-api">
                    ExchangeApi
                  </Link>
                </li>
              </ul>
            )}
          </div>
          <div className="top_right_btn d-inline-flex ms-auto ">
            {authenticated ? (
              <>
                <div className="nav-item dropdown ">
                  <a
                    className="nav-link nav-profile d-flex align-items-center pe-0"
                    href="#"
                    data-bs-toggle="dropdown"
                  >
                    <img
                      src={
                        profile?.profile_image
                          ? profile?.profile_image
                          : "/assets/img/sp1.jpg"
                      }
                      alt="Profile"
                      className="rounded-circle h-img"
                    />
                    <span className="ms-2" title={profile?.user_name}>
                      {profile?.user_name
                        ? profile?.user_name.length > 13
                          ? profile?.user_name.slice(0, 13) + "..."
                          : profile?.user_name
                        : ""}
                    </span>
                  </a>
                  <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                    <li className="dropdown-header">
                      <h6 className="mb-0" title={profile?.user_name}>
                        Welcome{" "}
                        {profile?.user_name
                          ? profile?.user_name.length > 13
                            ? profile?.user_name.slice(0, 13) + "..."
                            : profile?.user_name
                          : ""}
                      </h6>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>

                    <li>
                      <button
                        className="dropdown-item d-flex align-items-center"
                        onClick={handleShow}
                      >
                        <span>Change Password</span>
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item d-flex align-items-center"
                        onClick={logoutAlert}
                      >
                        <i className="bi bi-box-arrow-right me-2"></i>
                        <span>Log Out</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </nav>
      <ChangePasswordModal show={show} setShow={setShow} logout={logout} />
    </>
  );
}

export default Header;
